export const initialState = {
  isFetching: false,

  bestsellers: {
    products: [],
  },
  fragrance: {
    products: [],
  },
  newProducts: {
    products: [],
  },
  makeup: {
    products: [],
  },
  skincare: {
    products: [],
  },
  perfumeOfTheMonth: [],
  cologneOfTheMonth: [],
}

export const set = (state, payload) => (
  { ...payload, isFetching: false }
)

export const setFetching = (state, payload) => (
  { ...state, isFetching: payload }
)
